import { hideToast } from '@/redux/navigationSlice';
import { RootState } from '@/redux/store';
import { Toast } from '@repo/ui';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Renders a Toast component connected with Redux.
 *
 * @return {React.JSX.Element} The rendered Toast component.
 */
export const BackofficeToast = () => {
  const dispatch = useDispatch();
  const { open, kind, text, autoHide } = useSelector((state: RootState) => state.navigationdata.toastData);
  return (
    <Toast
      open={open}
      kind={kind}
      text={text}
      autoHideDuration={autoHide === false ? null : 5000}
      close={() => dispatch(hideToast())}
    />
  );
};
